// src/components/PortailFeuille.jsx — LE MÉCANISME GÉNÉRAL (règle Dimitri
// 22/08) : « quand une feuille est ouverte, PLUS RIEN de la page ne doit être
// lisible au-dessus du voile — aucune exception ».
//
// LA RACINE DU MAL (mesurée toute la journée, élément par élément — colonne,
// barre du bas, trait, codes, « C'est bon ») : les feuilles étaient rendues
// À L'INTÉRIEUR de l'arbre de la page ; le compositeur Chrome trie certaines
// couches du scroller (sticky, promus) AU-DESSUS d'un overlay fixed du même
// sous-arbre, quel que soit le z-index. Un correctif par élément n'en finit
// jamais.
//
// LE REMÈDE : la feuille (voile compris) monte par PORTAIL vers document.body
// — HORS de l'arbre de la page, DERNIÈRE du document. Aucune couche de la page
// ne peut la surplomber. `actif` permet de ne porter que l'habit étroit (les
// popovers ANCRÉS de l'ordinateur restent en place, au pixel).

import { createPortal } from 'react-dom'

export default function PortailFeuille({ actif = true, children }) {
  if (!actif || typeof document === 'undefined') return children
  return createPortal(children, document.body)
}
